import {
  MdEmail,
  MdFavorite,
  MdGroups,
  MdMenuBook,
  MdPerson,
  MdPhone,
  MdSelfImprovement,
  MdVolunteerActivism,
} from "react-icons/md";
import statusTone from "lib/statusTone";

const STATUS_LABELS = {
  pending: "Pending",
  in_progress: "In Progress",
  completed: "Completed",
  dismissed: "Dismissed",
};

const STATUS_TONES = {
  in_progress: "info",
  dismissed: "neutral",
};

const PRIORITY_TONES = {
  urgent: "danger",
  high: "warning",
  medium: "info",
  low: "neutral",
};

const TYPE_LABELS = {
  pastoral_care: "Pastoral Care",
  resource_delivery: "Resource Delivery",
  group_recommendation: "Group Recommendation",
  follow_up_call: "Follow-up Call",
  prayer_request: "Prayer Request",
  volunteer_interest: "Volunteer Interest",
  contact_request: "Contact Request",
  other: "Other",
};

const TYPE_ICONS = {
  pastoral_care: MdFavorite,
  follow_up_call: MdPhone,
  volunteer_interest: MdVolunteerActivism,
  resource_delivery: MdMenuBook,
  group_recommendation: MdGroups,
  contact_request: MdEmail,
  prayer_request: MdSelfImprovement,
};

export const STATUS_FILTER_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "pending", label: "Pending" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "dismissed", label: "Dismissed" },
];

export const PRIORITY_FILTER_OPTIONS = [
  { value: "", label: "All Priorities" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const TYPE_FILTER_OPTIONS = [
  { value: "", label: "All Types" },
  ...[
    "pastoral_care",
    "resource_delivery",
    "group_recommendation",
    "follow_up_call",
    "prayer_request",
    "volunteer_interest",
  ].map((value) => ({ value, label: TYPE_LABELS[value] })),
];

export const DATE_SORT_OPTIONS = [
  { value: "newest", label: "Newest First" },
  { value: "oldest", label: "Oldest First" },
];

export const PRAYER_STATUS_OPTIONS = [
  { value: "pending", label: "Needs Prayer" },
  { value: "answered", label: "Answered" },
  { value: "all", label: "All Requests" },
];

export const getStatusMeta = (status) => ({
  label: STATUS_LABELS[status] || status || STATUS_LABELS.pending,
  tone: STATUS_TONES[status] || statusTone(status || "pending"),
});

export const getPriorityMeta = (priority) => {
  const key = priority || "medium";
  return {
    label: `${key.charAt(0).toUpperCase()}${key.slice(1)} Priority`,
    tone: PRIORITY_TONES[key] || "info",
  };
};

export const getTypeLabel = (type) => TYPE_LABELS[type] || type;

export const getTypeIcon = (type) => TYPE_ICONS[type] || MdPerson;

export const getPrayerStatusMeta = (isAnswered) =>
  isAnswered
    ? { label: "Answered", tone: "success" }
    : { label: "Needs Prayer", tone: "warning" };

export const getActionItemName = (item) =>
  item.guest?.firstName && item.guest?.lastName
    ? `${item.guest.firstName} ${item.guest.lastName}`
    : item.response?.followUpName || item.title || "Anonymous Guest";
